import { Directionality } from "@angular/cdk/bidi";
import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, Optional, Renderer2 } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTagComponent } from "ng-zorro-antd/tag";
import { UiIconModule } from "../icon/icon.module";
import { UiLabelColor } from "./models/label.models";

@Component({
  selector: "ui-label",
  exportAs: "uiLabel",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.less"],
  host: {
    class: "ui-label",
    "[class]": `color ? ('ui-label-' + color) : ''`,
    "[class.accent]": "accent",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, UiIconModule],
})
export class UiLabelComponent extends NzTagComponent {
  @Input("uiAccent") @InputBoolean() public accent?: boolean;
  @Input("uiColor") public color?: UiLabelColor;
  @Input("uiIcon") public icon?: string;

  constructor(cdr: ChangeDetectorRef, renderer: Renderer2, elementRef: ElementRef, @Optional() directionality: Directionality) {
    super(cdr, renderer, elementRef, directionality);
  }
}
